
import Axios from 'axios'
import axios from 'axios'
import globalConfig from '../../../../globalConfig'

class API 
{
  constructor() 
  {
    axios.defaults.headers.common = {
      // 'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]').getAttribute('content'),
      'X-Requested-With': 'XMLHttpRequest',
    }
    Axios.defaults.baseURL = (process.env.NODE_ENV === 'development') ? 
      globalConfig.staging.puzzleDataApi : 
      globalConfig.production.puzzleDataApi
  }

  init(clientAppId) 
  {
    
    //console.log("referer :", window.location.href)
    return new Promise((resolve, reject) => {

      axios.get(`puzzle-data/${ clientAppId }/init`)
        .then(res => {
          resolve({
            appId: res.data.appId,
            titleHtml: res.data.titleHtml,
            type: res.data.type,
            name: res.data.name,
          })
        })
        //.catch(err => reject(err))
        .catch(err => {
          //console.log("blacklist");
          reject(err);
        })
    })
  }

  play(params) 
  {
    //console.log("play started")
    return new Promise((resolve, reject) => {
      axios.post(`puzzle-data/play`, {
        ClientAppId: params.clientAppId,
        PuzzleId: params.puzzleId,
        UserId: params.userId,
        PlayId: params.playId,
        ChallengeMode: params.challengeMode,
      })
      .then(res => resolve(res.data.PlayId))
      .catch(err => reject(err))
    })    
  }
  
  finish({clientAppId, finishedAt, playId, puzzleId, totalTimeInSeconds, userId, points, hintsUsed}) 
  {
    return new Promise((resolve, reject) => {
      axios.post(`puzzle-data/finish`, {
        ClientAppId: clientAppId,
        FinishedAt: finishedAt,
        PlayId: playId,
        PuzzleId: puzzleId,
        TotalTimeInSeconds: totalTimeInSeconds,
        UserId: userId,
        Points: points,
        HintsUsed: hintsUsed,
      })
      .then(res => resolve(res.data.PlayId))
      .catch(err => reject(err))
    })
  }
  
  rank(playId) 
  {
    return new Promise((resolve, reject) => {
      axios.post(`puzzle-data/rank`, {
        PlayId: playId,
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err))
    })
  }

  data(puzzleId) 
  {
    return new Promise((resolve, reject) => {
      axios.get('puzzle-data/data/' + puzzleId)
      .then(res => resolve(res.data))
      .catch(err => reject(err))        
    })        
  }

  triviaData(clientId, category) 
  {
    return new Promise((resolve, reject) => {
      axios.get(`puzzle-data/trivia/${clientId}/${category}`)
      .then(res => resolve(res.data))
      .catch(err => reject(err))        
    })        
  }

  WwData(clientAppId) {
    console.log(clientAppId)
    return new Promise((resolve, reject) => {
      axios.get(`puzzle-data/${ clientAppId }/wwdata`)
        .then(res => {
          let data = res.data; // Assign the response data to the data object
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  archive(clientAppId) 
  {
    let data = {}
    return new Promise((resolve, reject) => {
      axios.get(`puzzle-data/${ clientAppId }/archive`)
      .then(res => {
        if (!res.data.length) 
          throw new Error()

        // organise into arrays by date
        // TODO maybe do this server side?
        for (let i in res.data) {
          let dateStr = res.data[i].from.toString().split(' ')[0]
          
          // remove un-needed data
          delete res.data[i].to

          if (!data[dateStr])
            data[dateStr] = []

          data[dateStr].push(res.data[i])
        }

        resolve(data)
      })
      .catch(err => reject(err))
    })
  }

  postSupportTicket(body) 
  {
    
    return new Promise((resolve, reject) => {
      axios.post(`ticket`, {
        name: body.name,
        email: body.email,
        competitionId: body.competitionId,
        playId: body.PlayId,
        clientAppId: body.clientAppId,
        feedbackType: body.feedbackType,
        message: body.message,
        clientScheduleId: body.clientScheduleId,
        userAgent: window.navigator.userAgent,
        resolution: `${window.screen.width} X ${window.screen.height}`,
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err))
    })
  }

  competition(clientAppId) 
  {
    // return new Promise((resolve, reject) => {
    //   axios.get(`competitions/${clientAppId}/getCompetition`)
    //   .then(res => {
    //     resolve(res.data)
    //   })
    //   .catch(err => reject(err))
    // })

    return axios.get(`competitions/${clientAppId}/getCompetition`)
      .then(res => {
        return res.data; // Return res.data for further use if needed
      })
      .catch(err => {
        throw err;
      });

  }

  enterCompetion(body) 
  {
    
    return new Promise((resolve, reject) => {
      axios.post(`competitions/enter`, body)
        .then(res => resolve(res.data))
        .catch(err => {
          if (err.response.status === 429) // too many attempts/requests
            reject({ message: 'Too many submission attempts, you can only submit one per puzzle.' })
          if (err.response.status === 406)
            reject({ message: err.response.data.message})

          reject(err.response)
        })
    })
  }

}

export default new API()